export const getLeftAdjustment = (navSize: string) => {
  switch (navSize) {
    case "small": {
      return "-85px";
    }
    case "large": {
      return "-260px";
    }
    default: {
      return "0px";
    }
  }
};
